import { createSlice } from "@reduxjs/toolkit";

import InvoiceModel from "models/InvoiceModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';
import { getInvoices } from "services/invoice.service";

import { RootState } from "store/store";

interface InvoiceState {
    invoicesDto: ResultsDtoModel<InvoiceModel>;
    loading: boolean;
    error?: string | null;
    invoices?: { [id: number]: string } | null;
}

const initialState: InvoiceState = {
    invoicesDto: initialResultsDtoModel,
    loading: false,
    error: null
}

const demoInvoice: InvoiceModel[] = [
    {
        "invoiceNumber": "BCDINV091071",
        "serialNumbers": "8YYE41X04",
        "dueDate": new Date(),
        "transactionId": 62397785,
        "purchaseOrder": "500507708085",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Open"
    },
    {
        "invoiceNumber": "BCDINV091070",
        "serialNumbers": "4YDE45Z24",
        "dueDate": new Date(),
        "transactionId": 62397685,
        "purchaseOrder": "500507708985",
        "fileId": 12,
        "transactionDate": new Date(),
        "status": "Open"
    },
    {
        "invoiceNumber": "BCDINV091051",
        "serialNumbers": "3ZDE45Z24",
        "dueDate": new Date(),
        "transactionId": 62363785,
        "purchaseOrder": "500507709185",
        "fileId": 14,
        "transactionDate": new Date(),
        "status": "Paid In Full"
    },
    {
        "invoiceNumber": "BCDINV091050",
        "serialNumbers": "JYYE41X04",
        "dueDate": new Date(),
        "transactionId": 62363685,
        "purchaseOrder": "500507708485",
        "fileId": 16,
        "transactionDate": new Date(),
        "status": "Paid In Full"
    },

]

export const invoicesSlice = createSlice({
    name: "invoices",
    initialState,
    reducers: {
        clearInvoices: (state) => {
            state.invoicesDto = initialResultsDtoModel;
        },
        setDemoInvoices: (state) => {
            state.invoicesDto.items = demoInvoice
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInvoices.fulfilled, (state, action) => {
                state.invoicesDto = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getInvoices.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getInvoices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load invoices';
            })
    }
});

export const selectInvoicesDto = (state: RootState) => state.invoices.invoicesDto;
export const invoicesReducer = invoicesSlice.reducer;
export const { clearInvoices, setDemoInvoices } = invoicesSlice.actions;